import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Engine, Scene } from '@babylonjs/core';
import { Loading } from "src/app/components/loading/Loading";
import { SceneService } from "src/app/services/scene/scene.service";
import { WindowRefService } from "src/app/services/window-ref.service";

@Component({
  selector: "app-engine",
  templateUrl: "./engine.component.html",
})
export class EngineComponent implements OnInit {
  @ViewChild("rendererCanvas", { static: true })
  public rendererCanvas: ElementRef<HTMLCanvasElement>;
  private canvas: HTMLCanvasElement;
  private engine: Engine;
  private scene: Scene;
  public sceneLoaded = false;

  public constructor(
    private ngZone: NgZone,
    private windowRef: WindowRefService,
    private activatedRouter: ActivatedRoute,
    private http: HttpClient,
    private sceneService: SceneService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.activatedRouter.queryParams.subscribe((param) => {
      let client = param["client"];
      if (!client) {
        this.router.navigateByUrl("not-found");
      } else {
        let debugLayerEnabled = param["debugLayerEnabled"]
          ? param["debugLayerEnabled"]
          : false;
        // The first step is to get the reference of the canvas element from our HTML document
        this.canvas = this.rendererCanvas.nativeElement;

        // Then, load the Babylon 3D engine:
        this.engine = new Engine(this.canvas, true, {}, true);
        this.engine.setHardwareScalingLevel(0.75);
        this.engine.loadingScreen = new Loading("Simple");
        this.engine.displayLoadingUI();

        this.http
            // .get(`assets/data.json`)
           .get(`https://dl.dropbox.com/s/z01rrbi0b2ldebu/data.json`)
          .subscribe((data) => {
            //set loading
            // create scene
            this.scene = this.sceneService.createScene(
              this.canvas,
              this.engine,
              client,
              data,
              debugLayerEnabled
            );
            //animate
            this.animate();
          });
      }
    });
  }

  public animate(): void {
    // We have to run this outside angular zones,
    // because it could trigger heavy changeDetection cycles.
    this.ngZone.runOutsideAngular(() => {
      const rendererLoopCallback = () => {
        if (this.scene.isReady()) {
          this.scene.render(); //(true, true);
          // document
          //   .getElementById("engine-wrapper")
          //   .classList.remove("wrapper-hiden");
          this.sceneLoaded = true;
          this.engine.hideLoadingUI();
        }
      };

      if (this.windowRef.document.readyState !== "loading" && this.scene) {
        this.engine.runRenderLoop(rendererLoopCallback);
      } else {
        this.windowRef.window.addEventListener("DOMContentLoaded", () => {
          this.engine.runRenderLoop(rendererLoopCallback);
        });
      }
      this.windowRef.window.addEventListener("resize", () => {
        this.engine.resize();
      });
    });
  }

  // public constructor(
  //   private engServ: EngineService,
  //   private sceneService: SceneService
  // ) {}

  // public ngOnInit(): void {
  //   this.engServ.createScene(this.rendererCanvas);
  //   //this.sceneService.createScene();
  // }
}
